import { axiosWithConfig } from '@assembly/config/axios'

const path = `/admin/contracts`

export interface ContractVersionInfo {
  versionCode: string
  description: string
  availableCountries: string[]
}

export interface ContractVersionsResponse {
  [versionCode: string]: ContractVersionInfo
}

export interface StatusMessage {
  status: string
  message: string
}

/**
 * Get all available contract versions with their supported countries
 */
export const getAvailableContractVersions = (): Promise<{ data: ContractVersionsResponse }> => {
  return axiosWithConfig.get(`${path}/versions`)
}

/**
 * Get contract HTML for a specific country and version
 */
export const getContractByCountryAndVersion = (
  countryCode: string,
  versionCode: string
): Promise<{ data: StatusMessage }> => {
  return axiosWithConfig.get(`${path}/${countryCode}/${versionCode}`)
}

